import React from "react";

import { PolicyDetails } from "../../layouts/policyDetails/PolicyDetails";

const PolicyDetailsWrapper = (props) => <PolicyDetails {...props} />;

export default PolicyDetailsWrapper;
